import { requisitarJson } from '../../../shared/api/http';

/** As páginas de Configurações que têm histórico: as fases e a aba Textos. */
export type PaginaDoHistorico = 'scanpixel' | 'menuresolucao' | 'labpixels' | 'versus' | 'player1' | 'textos';

export interface ItemDoHistorico {
    id: string;
    ocorrido_em: string;
    /** "AutoU" ou "Fiat": os dois logins do painel. */
    autor: string;
    descricao: string;
}

export interface HistoricoDaPagina {
    pagina: PaginaDoHistorico;
    itens: ItemDoHistorico[];
}

export function obterHistorico(pagina: PaginaDoHistorico): Promise<HistoricoDaPagina> {
    return requisitarJson(`/api/v1/configuracoes/historico?pagina=${encodeURIComponent(pagina)}`);
}
